import { render, staticRenderFns } from "./CommentsItem.vue?vue&type=template&id=6c458de3&scoped=true&"
import script from "./CommentsItem.vue?vue&type=script&lang=js&"
export * from "./CommentsItem.vue?vue&type=script&lang=js&"
import style0 from "./CommentsItem.vue?vue&type=style&index=0&id=6c458de3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c458de3",
  null
  
)

export default component.exports